import { useSelector } from "react-redux";

import { LineItemSelectWithExact } from "components/formFields/LineItemSelectWithExact";
import { LineItemText } from "components/formFields/LineItemText";
import { LineTableCell } from "components/formFields/LineTableCell";

export function LineCustomer(props) {
  const { value, customers, onValueChange, lineReadOnly = false } = props;

  const showCustomerOnPurchaseForms = useSelector(
    (state) => state.userCompanySettings.settings.showCustomerOnPurchaseForms
  );

  const findCustomerByFullName = useSelector(
    (state) => state.userCompanySettings.settings.findCustomerByFullName
  );

  if (!showCustomerOnPurchaseForms) {
    return null;
  }

  if (lineReadOnly) {
    return (
      <LineTableCell
        sx={{
          fontSize: "0.8125rem",
          padding: "0.5rem 0.7rem",
          minWidth: "13rem",
        }}
      >
        <LineItemText
          value={
            findCustomerByFullName ? value?.fullname || "" : value?.name || ""
          }
        />
      </LineTableCell>
    );
  }

  return (
    <LineTableCell sx={{ minWidth: "13rem" }}>
      <LineItemSelectWithExact
        name="customer"
        options={customers}
        optionDisplayText={findCustomerByFullName ? "fullname" : "name"}
        value={value}
        onValueChange={onValueChange}
        allowTooltip={true}
        dataTesting="customer"
      />
    </LineTableCell>
  );
}
